import React from 'react';

export default class HiddenFields extends React.Component {
    constructor(props) {
        super( props );
    }
    render() {
        return (
            <div>
                <input type="hidden" name="usertype" value="professor"/>
                <input type="hidden" id="cc" name="cc" value="us"/>
                <input type="hidden" id="lang" name="lang" value="en"/>
                <input type="hidden" id="onlineFulfillment" name="onlineFulfillment" value="true"/>
                <input type="hidden" id="isbn" name="isbn" value="9780190457426"/>
                <input type="hidden" id="__disabled" name="__disabled" value=""/>
            </div>
        );
    }
};


// WEBPACK FOOTER //
// ./src/form/components/HiddenFields.jsx